const buildPaginationString = (facet) => {
    const { name, selected } = facet;
    const facetQsa = `&facet=${name}`;
    return selected ? facetQsa : '';
}

export default buildPaginationString;